module.exports = __webpack_public_path__ + "img/x4.647bd5eb.jpg";